// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageTextCard_wrapper__q62Hm","image":"ImageTextCard_image___P8vw","container":"ImageTextCard_container__2O1nJ","heading":"ImageTextCard_heading__E0bih"};